// 公共样式
export const commonStyle = {
    rotate: 0,
    opacity: 1,
}

export const commonAttr = {
    animations: [],
    events: {},
    groupStyle: {}, // 当一个组件成为 Group 的子组件时使用
    isLock: false, // 是否锁定组件
    collapseName: 'style', // 编辑组件时记录当前使用的是哪个折叠面板，再次回来时恢复上次打开的折叠面板，优化用户体验
    linkage: {
        duration: 0, // 过渡持续时间
        data: [ // 组件联动
            {
                id: '', // 联动的组件 id
                label: '', // 联动的组件名称
                event: '', // 监听事件
                style: [{ key: '', value: '' }], // 监听的事件触发时，需要改变的属性
            },
        ],
    },
}

// 编辑器左侧组件列表
const list = [
    {
        component: 'VText',
        label: '文字',
        propValue: '双击编辑文字',
        icon: 'wenben',
        request: {
            method: 'GET',
            data: [],
            url: '',
            series: false, // 是否定时发送请求
            time: 1000, // 定时更新时间
            paramType: '', // string object array
            requestCount: 0, // 请求次数限制，0 为无限
        },
        style: {
            width: 200,
            height: 28,
            fontSize: '',
            fontWeight: 400,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: '',
            color: '',
        },
    },
    {
        component: 'VButton',
        label: '按钮',
        propValue: '按钮',
        icon: 'button',
        style: {
            width: 100,
            height: 34,
            borderWidth: 1,
            borderColor: '',
            borderRadius: '',
            fontSize: '',
            fontWeight: 400,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: '',
            color: '',
            backgroundColor: '',
        },
    },
    {
        component: 'Picture',
        label: '图片',
        icon: 'tupian',
        propValue: {
            url: require('@/assets/title.jpg'),
            flip: {
                horizontal: false,
                vertical: false,
            },
        },
        style: {
            width: 300,
            height: 200,
            borderRadius: '',
        },
    },
    {
        component: 'RectShape',
        label: '矩形',
        propValue: '&nbsp;',
        icon: 'juxing',
        style: {
            width: 200,
            height: 200,
            fontSize: '',
            fontWeight: 400,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: 'center',
            color: '',
            borderColor: '#000',
            borderWidth: 1,
            backgroundColor: '',
            borderStyle: 'solid',
            borderRadius: '',
            verticalAlign: 'middle',
        },
    },
    {
        component: 'LineShape',
        label: '直线',
        propValue: '',
        icon: 'zhixian',
        style: {
            width: 200,
            height: 2,
            backgroundColor: '#000',
        },
    },
    {
        component: 'CircleShape',
        label: '圆形',
        propValue: '&nbsp;',
        icon: '24gl-circle',
        style: {
            width: 200,
            height: 200,
            fontSize: '',
            fontWeight: 400,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: 'center',
            color: '',
            borderColor: '#000',
            borderWidth: 1,
            backgroundColor: '',
            borderStyle: 'solid',
            borderRadius: '',
            verticalAlign: 'middle',
        },
    },
    {
        component: 'SVGStar',
        label: '星形',
        icon: 'kongwujiaoxing',
        propValue: '',
        style: {
            width: 80,
            height: 80,
            fontSize: '',
            fontWeight: 400,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: 'center',
            color: '',
            borderColor: '#000',
            backgroundColor: 'rgba(255, 255, 255, 1)',
        },
    },
    {
        component: 'SVGTriangle',
        label: '三角形',
        icon: 'xingzhuang-sanjiaoxing',
        propValue: '',
        style: {
            width: 80,
            height: 80,
            fontSize: '',
            fontWeight: 400,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: 'center',
            color: '',
            borderColor: '#000',
            backgroundColor: 'rgba(255, 255, 255, 1)',
        },
    },
    {
        component: 'VTable',
        label: '表格',
        icon: 'biaoge',
        propValue: {
            data: [
                ['表头1', '表头2', '表头3'],
                ['内容1', '内容2', '内容3'],
            ],
            stripe: true,
            thBold: true,
        },
        request: {
            method: 'GET',
            data: [],
            url: '',
            series: false,
            time: 1000,
            paramType: '', // string object array
            requestCount: 0, // 请求次数限制，0 为无限
        },
        style: {
            width: 600,
            height: 200,
            fontSize: '',
            fontWeight: 400,
            textAlign: 'center',
            color: '',
            backgroundColor: 'rgba(255, 255, 255, 1)',
        },
    },
    {
        component: 'TCarousel',
        label: '轮播图',
        propValue: {
            urls: [
                'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
                'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg',
                'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg',
                'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
                'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
                'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg',
                'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg',
            ],
            interval: 1000,
            type: 'none',
            fit: 'contain',
            flip: {
                horizontal: false,
                vertical: false,
            },
        },
        icon: 'lunbotu',
        style: {
            width: 300,
            height: 200,
            borderRadius: '',
        },
    },
    {
        component: 'TWeather',
        label: '天气',
        propValue: {
            config: {
                modules: '01234',
                background: '1',
                backgroundColor: '',
                tmpColor: '#FFFFFF',
                tmpSize: '16',
                cityColor: '#FFFFFF',
                citySize: '16',
                aqiColor: '#FFFFFF',
                aqiSize: '16',
                weatherIconSize: '24',
                alertIconSize: '18',
                padding: '10px 10px 10px 10px',
                shadow: '0',
                language: 'auto',
                borderRadius: '5',
                fixed: 'false',
                vertical: 'top',
                horizontal: 'left',
                city: 'CN101230702',
                key: '816ff1a3beca4082ab3b8a4f2861f3e9',
                overflow: 'hidden',
            },
            flip: {
                horizontal: false,
                vertical: false,
            },
        },
        icon: 'tianqi',
        style: {
            width: 179,
            height: 42,
            borderRadius: '2px',
        },
    },
    {
        component: 'TCountdown',
        label: '倒计时',
        propValue: {
            startTime: '2019-06-16 15:46:55',
            endTime: '2025-06-16 15:46:55',
            showDays: true,
            showHours: true,
            showMinutes: true,
            showSeconds: true,
            labels: {
                days: 'Days',
                hours: 'Hours',
                minutes: 'Minutes',
                seconds: 'Seconds',
            },
            countdownSize: '3',
            labelSize: '1.2',
            flip: {
                horizontal: false,
                vertical: false,
            },
        },
        icon: 'daojishi',
        style: {
            width: 300,
            height: 50,
            borderRadius: '',
        },
    },
    {
        component: 'TClock',
        label: '时钟',
        propValue: {
            startTime: '2019-06-16 15:46:55',
            endTime: '2025-06-16 15:46:55',
            showDays: true,
            showHours: true,
            showMinutes: true,
            showSeconds: true,
            labels: {
                days: 'Days',
                hours: 'Hours',
                minutes: 'Minutes',
                seconds: 'Seconds',
            },
            countdownSize: '3',
            labelSize: '1.2',
            flip: {
                horizontal: false,
                vertical: false,
            },
        },
        icon: 'shizhong',
        style: {
            width: 120,
            height: 42,
            borderRadius: '',
        },
    },
    {
        component: 'TVideo',
        label: '视频',
        propValue: {
            type: 'mp4',
            isLive: false,
            src: 'https://fusion.alicdn.com/images/page-1.mp4',
            controls: true,
            loop: true,
            autoplay: true,
            muted: true,
            borderRadius: 0,
            flip: {
                horizontal: false,
                vertical: false,
            },
        },
        icon: 'zhibo',
        style: {
            width: 400,
            height: 260,
            borderRadius: '',
        },
    },
]

for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    item.style = { ...commonStyle, ...item.style }
    list[i] = { ...commonAttr, ...item }
}

export default list
